module.exports = __webpack_public_path__ + "img/technology2.68102aa4.jpeg";